import AxiosPermisos  from '@/services/axiosPermisos'

import {
    paths
} from './path'

const getMyLaborUnionService = async () => await AxiosPermisos.get(paths.me, true, 'v2')

const getSettingService = async ({ id, key}) => await AxiosPermisos.get(paths.setting.replace(':id', id).replace(':key', key), true, 'v2')

export {
    getMyLaborUnionService
    , getSettingService
}